import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../../modules';
import { ContentsItem } from '../../../modules/editor/types';
import { parseStyle } from '../../../util/parseStyle';

import PartitionToolbar from '../Toolbar/PartitionToolbar';


type Props = {
	contentItem: ContentsItem
};

function Partition({ contentItem }: Props) {
	const [showToolbar, setShowToolbar] = useState(false);	

	const selectedContentId = useSelector((state: RootState) => state.editor.selectedContentId);

	useEffect(() => {
		if (selectedContentId !== contentItem.id) {
			unselectContent();
		}
	}, [selectedContentId]);

	const startEditing = () => {
		setShowToolbar(true);
	}

	const unselectContent = () => {
		setShowToolbar(false);
	}

	return (
		<div className={showToolbar ? 'partition-edit active' : 'partition-edit'}>
			<div
				className="partition-edit-content"
				style={parseStyle(contentItem?.content?.style[0]?.partition)}
				onClick={startEditing}
			></div>
			{
				showToolbar ? (
					<PartitionToolbar
						innerContent={contentItem.content.content[0]}
						style={contentItem.content.style[0].partition}
						contentId={contentItem.id}
						contentIndex={0}
					/>
				) : (
					<div
						className="cover"
						onClick={startEditing}
					>
					</div>
				)
			}
		</div>
	)
}

export default Partition;